<template>
  <div>
    <div v-if="data">
      <div style="display: block; margin: 20px">
        <v-icon
            size="x-large"
            class="icon-item"
            :class="mode==='CHART' ? 'icon-poll' : 'icon-poll-grey'"
            @click="mode='CHART'"
        ></v-icon>
        <v-icon size="x-large"
                style="margin-left:15px"
                class="icon-item"
                :class="mode==='TABLE' ? 'icon-table' : 'icon-table-grey'"
                @click="mode='TABLE'"
        ></v-icon>
      </div>
      <div v-if="mode==='CHART'">
        <table class="rating_table">
          <tr class="header_table">
            <td colspan="1" v-if="!hideRankingPosition">№</td>
            <td colspan="7">Регион / ЦЗН</td>
            <td colspan="17" v-if="data.some(row => row[3] !== undefined) && data.some(row => row[3] !== null)">Рейтинг</td>
            <td colspan="3" v-if="data.some(row => row[3] !== undefined) && data.some(row => row[3] !== null)">Показатель, {{data[0][4]}}</td>
            <td colspan="20" v-else>Рейтинг</td>
          </tr>
          <tr v-for="(row, rowIndex) in data" :key="'chart_'+rowIndex">
            <td colspan="1" v-if="!hideRankingPosition">{{ row[2] }}.</td>
            <td colspan="7">{{ truncateStr(row[0], 40) }}</td>
            <template v-if="row[3] !== undefined && row[3] !== null">
              <td colspan="17">
                <div class="rating_bar" :style="'width: ' + row[1] * 0.9 + '%'" v-if="row[1] > 0">_</div>
                {{ Math.round(row[1] * 100) / 100 }}
              </td>
              <td colspan="3">
                {{ Math.round(row[3] * 100) }}
              </td>
            </template>
            <template v-else>
              <td colspan="20">
                <div class="rating_bar" :style="'width: ' + row[1] * 0.9 + '%'" v-if="row[1] > 0">_</div>
                {{ Math.round(row[1] * 100) / 100 }}
              </td>
            </template>
          </tr>
          <tr v-if="legend">
            <td></td><td colspan="5"></td><td colspan="20">{{legend}}</td>
          </tr>
        </table>
      </div>
      <div v-if="mode==='CHART_old'">
        <GChart
            type="BarChart"
            :data="getChartData()"
            :options="chartOptions"
        />
      </div>
      <div v-if="mode==='TABLE'">
        <table>
          <tr>
            <th>Субъект РФ / ЦЗН</th>
            <th>Значение</th>
            <th v-if="!hideRankingPosition">Место в рейтинге</th>
            <th></th>
          </tr>
          <tr v-for="(row, rowIndex) in data" :key="'_'+rowIndex">
            <td>
              {{ row[0] }}
            </td>
            <td>
              {{Math.round(row[1]*100)/100}}
            </td>
            <td v-if="!hideRankingPosition">
              {{row[2]}}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <v-progress-linear
        v-else
        indeterminate
        color="primary"
    ></v-progress-linear>
  </div>
</template>

<script>

import {GChart} from "vue-google-charts/legacy";
import {addRatingColumn} from "@/modules/ReportUtils";

export default {
  name: 'ResultMonitorRatingContent',
  components: {GChart},
  props: ['period', 'level', 'regionAndDepartmentInfo', 'reportDataFunction', 'legend', 'onlyCurrentRegion', 'onlyCurrentDepartment'],
  computed: {
    hideRankingPosition() {
      return this.onlyCurrentRegion || this.onlyCurrentDepartment;
    },
  },
  data: () => ({
    mode: 'CHART',
    data: undefined,
    chartOptions: {
      backgroundColor: 'transparent',
      legend: {position: "none"},
      height: 1100,
      chartArea: {width: '60%', left: 100, top: 10, height: '95%'},
      hAxis: {
        minValue: 0,
        textStyle: {
          fontSize: 10
        }
      },
      vAxis: {
        color: '#333', textStyle: {
          fontSize: 10
        }
      },
      annotations: {
        textStyle: {
          fontSize: 10,
          color: '#000',
        }
      },
      series: {
        0: {color: '#69B3E7'},
      }
    },
  }),
  methods: {
    truncateStr(str, n = 30) {
      if (!str) return str
      if (str.length > n) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
      }
      return str;
    },
    getChartData(){
      let res = this.data?.map((e, index)=>[(index+1)+'. '+e[0], e[1]])
      res?.unshift(["Субъект РФ/ЦЗН", "Значение"])
      return res
    },
    async init(){
      this.data = undefined
      this.data = await this.reportDataFunction(this.level, this.period, this.regionAndDepartmentInfo)
      if (this.onlyCurrentRegion && this.level !== 'czn') {
        this.data = this.data.filter(e=>e[0]===this.$user.region.name)
      }
      if (this.onlyCurrentDepartment && this.level === 'czn') {
        this.data = this.data.filter(e => e[0] === this.$user.department.name)
      }
      addRatingColumn(this.data)
    }
  },
  watch: {
    regionAndDepartmentInfo: {
      async handler() {
        await this.init()
      },
      deep: true
    },
    period: {
      async handler() {
        await this.init()
      }
    },
    level: {
      async handler() {
        await this.init()
      }
    }
  },
  async beforeMount() {
    await this.init()
  }
}
</script>

<style scoped>
.rating_table{
  width: 100%;
  table-layout: fixed;
  border-spacing: 0
}

.rating_bar {
  background-color: #2F80ED;
  color: #2F80ED;
  margin-right: 5px;
  display: inline-block;
}

.rating_table td {
  font-size: 10px;
  padding: 0!important;
}

.rating_table tr {
  padding: 0;
}

.header_table td{
  font-weight: bold;
  font-size:10px;
}
</style>
